import React, { useState } from 'react';
import { CommissionsBoard, Layout } from 'features/command-center';
import usePageTitle from 'hooks/usePageTitle';
import strings from 'strings';
import { PageTitles } from 'UI/constants/defaults';

export const CommissionsBoardPage = () => {
  const [triggerRefreshKey, setTriggerRefreshKey] = useState(0);

  usePageTitle({ title: PageTitles.CommandCenterCommissionsBoard });

  const handleClickRefresh = () => {
    setTriggerRefreshKey(prev => prev + 1);
  };

  return (
    <Layout
      title={strings.commandCenter.commissionsBoard.title}
      path={strings.commandCenter.title}
      onRefresh={handleClickRefresh}
    >
      <CommissionsBoard key={triggerRefreshKey} />
    </Layout>
  );
};
